// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__NDV1H","legacyBtn":"MutateMid_legacyBtn__2ENF2"};